import { render, staticRenderFns } from "./AssessmentHistoryChart.vue?vue&type=template&id=7ade4cfc&"
import script from "./AssessmentHistoryChart.vue?vue&type=script&lang=js&"
export * from "./AssessmentHistoryChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports